<template>
  <div class="list-view-filter-row">
    <v-select
      v-model.lazy="promoState"
      density="compact"
      persistentPlaceholder
      hideDetails
      label="Prompt State"
      :items="promoStateList"
      :menuProps="{ offsetY: true }"
      itemTitle="text"
      placeholder="All"
      multiple
      class="list-view-filter-menu"
    >
      <template #selection="{ item, index }">
        <span v-if="index === 0">{{ truncate(item.raw.text, 12) }}</span>
        <span v-if="index === 1" class="caption">[+{{ promoState.length - 1 }}]</span>
      </template>
    </v-select>
    <v-select
      v-model="filterPlacementsSegment"
      class="list-view-filter-menu"
      persistentPlaceholder
      label="Segments"
      hideDetails
      density="compact"
      itemTitle="name"
      itemValue="id"
      :items="segmentListWithHeaders"
      :menuProps="{ offsetY: true }"
      placeholder="All"
      multiple
    >
      <template #selection="{ item, index }">
        <span v-if="index === 0">{{ truncate(item.raw.name, 12) }}</span>
        <span v-if="index === 1" class="caption">[+{{ filterPlacementsSegment.length - 1 }}]</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import FilterMixin from "@/utils/FilterMixin";
import StringUtils from "@/utils/StringUtils";

export default {
  name: "PlacementPromoFilters",
  mixins: [FilterMixin],
  props: ["model"], // used inside FilterMixin -> SegmentListMixin,
  setup: () => ({ truncate: StringUtils.truncate }),
};
</script>

<style></style>
